/** Static section copy (not from CMS API) — EN / AR / KU */
export const sectionTranslations = {
  en: {
    estimator: {
      hero: {
        badge: "COST ESTIMATE",
        title: "IRQGYP Estimation",
        titleLine2: "Calculator",
        desc1:
          "The IRQGYP Estimate Calculator helps you make fast, accurate, and informed project decisions before construction even begins.",
        desc2:
          "Developed by our technical and digital teams, this online tool allows architects, contractors, and project managers to calculate material quantities, system coverage, and cost estimates for gypsum-based applications, all in a few clicks.",
        cta: "Calculate now",
        imageAlt: "Estimator",
      },
      how: {
        tag: "HOW IT WORKS",
        title: "See how",
        titleAccent: "calculation works",
        steps: {
          s1Title: "Enter your area",
          s1Text: "Input the total amount you want to cover and select your measuring type.",
          s2Title: "Select your wall and profile type",
          s2Text: "Choose the wall type and metal profile that suits your project.",
          s3Title: "Get your materials list",
          s3Text:
            "The calculator instantly generates the quantity of gypsum boards, screws, metal profiles, joint filler, and anchors needed.",
          s4Title: "Download your estimate",
          s4Text:
            "Save your results as a PDF to use as a reference before purchasing materials or starting construction.",
        },
      },
      benefits: {
        title: "How can our",
        titleAccent: "calculator help you",
        subtitle: "Our calculator gives you the exact materials you need before you start building",
        points: {
          p1: "Saves time in project planning",
          p2: "Reduces waste and over-ordering",
          p3: "Aligns quantities with IRQGYP's verified systems",
          p4: "Generates instant PDF reports for submittals or client presentations",
          p5: "Accuracy begins with knowledge.",
        },
        cta: "Calculate now",
        imageAlt: "Estimator worker",
      },
      calculator: {
        badge: "CALCULATOR",
        title: "Drywall",
        titleAccent: "Estimator",
        subtitle: "Plan smarter before your project begins.",
        calculateArea: "Calculate area",
        heightPlaceholder: "Height (m)",
        widthPlaceholder: "Width (m)",
        frameSingle: "Single Frame",
        frameDouble: "Double Frame",
        boardOne: "One board each side",
        boardTwo: "Two board each side",
        calculate: "Calculate",
        note:
          "Please note: The results provided in this estimate are approximate and may vary by ±10% depending on site conditions and installation practices.",
        callbackPrefix: "Still not sure how calculation works?",
        callbackLink: "Request a call back",
        description: "Description",
        amount: "Amount",
        totalArea: "Total {{unit}}",
        board: "Gypsum Board 1,200x2400mm (1,2x2.4m)",
        trackUd: "Metal Profile Track (UD)",
        studCw: "Metal Profile Stud (CW)",
        jointTape: "Joint Tape",
        jointCompound: "Joint Compound",
        screws25: "Drywall Screws (M3.5x25 mm)",
        screws35: "Drywall Screws (M3.5x35 mm)",
        waferHead: "Wafer Head Screw",
        anchors: "Anchors",
        studSpacing: "Stud Spacing",
        studSpacingValue: "600 mm",
        waste: "Waste",
        wasteValue: "5-10%",
        resultHint: "Fill fields and click Calculate to preview results.",
        unitPcs: "pcs",
        unitM: "m",
        unitKg: "kg",
        downloadPdf: "Download in PDF",
        pdfTitle: "Drywall Estimator Report",
        pdfInput:
          "Input: H {{height}}m x W {{width}}m | {{frame}} | {{boardSides}}",
        pdfDateGenerated: "Date Generated: {{date}}",
        pdfNoteLabel: "Note:",
        pdfNoteText: "Waste: 5-10% | Calculation based on Stud Spacing 600 mm.",
      },
    },
    blog: {
      heroTitle: "Our blog",
      tag: "BLOG POSTS",
      listTitle: "Latest news and articles",
      readArticle: "Read article",
      loadMore: "Load more",
    },
    terms: {
      heroTitle: "Terms and conditions",
      heroDesc:
        "Please read these terms carefully before using the IRQGYP website or engaging with our products and services. By accessing this website, you agree to be bound by the terms outlined below.",
      lastUpdated: "Last updated: April 2026",
    },
    allSolutions: {
      constNeed: {
        tag: "OUR SOLUTIONS",
        titleLine1: "Integrated Systems",
        titleLine2: "for Every",
        titleAccent: "Construction Need",
        intro:
          "IRQGYP delivers integrated solutions across every stage of construction, the complete solution from foundations to final finishes.",
        moreDetails: "More Details",
      },
      products: {
        tag: "OUR PRODUCTS",
        titleLine1: "Explore product categories",
        titleLine2: "within our solutions",
      },
      downloads: {
        tag: "DOWNLOADS",
        title: "Available downloads",
        descWithItems: "Technical PDFs from our solutions — open or download from the list below.",
        descEmpty: "No solution PDFs are available at the moment. Check back later.",
      },
      requestProject: {
        tag: "CONTACT US",
        title: "Starting a",
        titleAccent: "new project?",
        text: "IRQGYP is a leading Iraqi company specialized in gypsum products and modern construction solutions — headquartered in Baghdad.",
        getQuote: "Get a quote",
        requestCallback: "Request a Call back",
        imageAlt: "Worker holding gypsum board",
      },
    },
    academy: {
      whyUs: {
        tag: "WHY IRQGYP",
        title: "Get a recognized",
        titleAccent: "certification in Iraq",
        text: "Your skills deserve recognition. IRQGYP's certification is your proof of expertise in drywall and modern construction systems.",
        cta: "Discover courses",
        features: {
          f1: "IRQGYP certified",
          f2: "Recognized in Iraq & region",
          f3: "Professional results",
          f4: "Employment guarantee",
        },
      },
      courses: {
        tag: "COURSES",
        title: "Available",
        titleAccent: "Courses",
        text: "IRQGYP is a leading Iraqi company specialized in gypsum products and modern construction solutions — headquartered in Baghdad.",
      },
      getInTouch: {
        tag: "LET'S GET IN TOUCH",
        title: "Do you have",
        titleAccent: "more question?",
        text: "Whether you need more information about our products, services, or project support, our team is here to help. Fill out the form and we'll get back to you as soon as possible with the answers and guidance you need.",
        formTitle: "Fill out the form",
      },
      questions: {
        tag: "QUESTIONS",
        title: "Do you have",
        titleAccent: "more question?",
        text: "Whether you need more information about our products, services, or project support, our team is here to help. Fill out the form and we'll get back to you as soon as possible with the answers and guidance you need.",
        formTitle: "Ask a question",
      },
    },
    careers: {
      openRoles: "Open roles",
      roleLabel: "Role",
      noJobs: "There are no open roles at the moment.",
      followSubtitle: "Follow us for updates on new opportunities or subscribe to be notified.",
      emailPlaceholder: "Enter your email and be notified for new roles",
      subscribe: "Subscribe",
      followSocial: "Follow us on social media",
      hero: {
        tag: "CAREER",
        title: "Join our team",
        description:
          "Join IRQGYP and grow your career in a dynamic team that values quality, innovation, and collaboration, where your skills are valued and your future is built with purpose and impact",
        ctaText: "View open roles",
      },
    },
    products: {
      boards: {
        tag: "CATEGORIES",
        title: "Boards",
        desc: "Our boards provide high performance and durability for interior and exterior use, offering a stable base for walls and ceilings. Easy to install and system-compatible, they ensure long-lasting strength and quality results.",
        exploreAll: "Explore all products",
      },
      drywallFrame: "Drywall metal frame",
      ceilingFrame: "Ceiling metal frame",
      categoryHero: {
        tag: "CATEGORIES",
        exploreAll: "Explore all products",
        accessories: {
          title: "Accessories",
          desc: "Our accessories are designed to complete drywall and ceiling systems with precision and reliability, enhancing installation efficiency and overall performance. Fully compatible with our boards and metal framing systems, they ensure secure finishing.",
        },
        drywall: {
          title: "Drywall metal frame",
          desc: "Our drywall metal framing systems provide strength, precision, and durability. creating a reliable structure for walls, ceilings, and partitions. Easy to install and fully system-compatible, they ensure stability, accuracy, and long-lasting performance.",
        },
        ceiling: {
          title: "Ceiling metal frame",
          desc: "Our ceiling metal framing systems provide strength, stability, and precision for suspended ceiling applications, creating a dependable structure for flat and decorative ceiling designs",
        },
      },
      continueExploring: {
        titleLine1: "Continue exploring",
        titleLine2: "other categories",
      },
      continueProducts: {
        tag: "PRODUCTS",
        titleLine1: "Continue exploring",
        titleLine2: "other products",
        desc: "We offer a full range of high-quality construction materials, including gypsum boards, drywall and ceiling metal profiles, and essential accessories.",
      },
      boardTabs: {
        keyFeatures: "Key features",
        description: "Description",
        specifications: "SPECIFICATIONS",
        applications: "Applications",
        installationRecommendations: "Installation Recommendations",
        sustainability: "Sustainability",
        storageTitleStrong: "Storage, Handling",
        storageTitleSoft: "and on-Site Protection",
        disclaimer: "Disclaimer",
        disclaimerBody:
          "This datasheet is based on current manufacturing knowledge and laboratory testing. Declared values are nominal and may vary within normal production tolerances. The manufacturer is not liable for failures resulting from improper storage, handling, installation, modification, or use outside intended service conditions.",
      },
      detailTabs: {
        features: "Features",
        recommendations: "Recommendations",
        sustainability: "Sustainability",
        standards: "Standards",
        specifications: "Specifications",
        dimensions: "Dimensions",
        downloads: "Downloads",
      },
    },
    projects: {
      exploreTitle: "Explore all projects",
      sectorsFilter: "Sectors:",
    },
    sectors: {
      tag: "SECTORS",
      title: "Explore our sectors",
      aboutThisSector: "About this sector",
      benefitsTitle: "Benefits of IRQGYP",
      benefitsTitleAccent: "solutions",
      interiorWalls: "Interior Walls",
      ceilingSystems: "Ceiling Systems",
      exteriorCladding: "Exterior Cladding",
    },
    solutions: {
      systemDescription: "System description",
      downloads: {
        tag: "DOWNLOADS",
        title: "Available downloads",
        description: "Technical PDFs and documents for this solution.",
        downloadAll: "Download all files",
        empty: "No downloads found.",
      },
    },
    home: {
      blogPosts: {
        tag: "BLOG POSTS",
        title: "Latest news and articles",
        readArticle: "Read article",
      },
    },
  },
  ar: {
    estimator: {
      hero: {
        badge: "تقدير التكلفة",
        title: "حاسبة تقدير",
        titleLine2: "IRQGYP",
        desc1:
          "تساعدك حاسبة تقدير IRQGYP على اتخاذ قرارات مشروع سريعة ودقيقة ومستنيرة قبل بدء البناء.",
        desc2:
          "طوّرتها فرقنا التقنية والرقمية، وتتيح هذه الأداة للمهندسين والمقاولين ومديري المشاريع حساب كميات المواد وتغطية الأنظمة وتقديرات التكلفة لتطبيقات الجبس ببضع نقرات.",
        cta: "احسب الآن",
        imageAlt: "حاسبة التقدير",
      },
      how: {
        tag: "كيف تعمل",
        title: "اطلع على",
        titleAccent: "آلية الحساب",
        steps: {
          s1Title: "أدخل المساحة",
          s1Text: "أدخل إجمالي المساحة المراد تغطيتها واختر نوع القياس.",
          s2Title: "اختر نوع الجدار والبروفيل",
          s2Text: "اختر نوع الجدار والبروفيل المعدني المناسب لمشروعك.",
          s3Title: "احصل على قائمة المواد",
          s3Text: "تولّد الحاسبة فوراً كميات ألواح الجبس والبراغي والبروفيلات والمعجون والمراسي المطلوبة.",
          s4Title: "حمّل تقديرك",
          s4Text: "احفظ النتائج كملف PDF للرجوع إليها قبل شراء المواد أو بدء البناء.",
        },
      },
      benefits: {
        title: "كيف يمكن لـ",
        titleAccent: "حاسبتنا مساعدتك",
        subtitle: "تمنحك حاسبتنا المواد الدقيقة التي تحتاجها قبل البدء بالبناء",
        points: {
          p1: "يوفر الوقت في تخطيط المشروع",
          p2: "يقلل الهدر والطلب الزائد",
          p3: "يوائم الكميات مع أنظمة IRQGYP المعتمدة",
          p4: "ينشئ تقارير PDF فورية للتقديم أو العروض",
          p5: "الدقة تبدأ بالمعرفة.",
        },
        cta: "احسب الآن",
        imageAlt: "عامل تقدير",
      },
      calculator: {
        badge: "الحاسبة",
        title: "مقدّر",
        titleAccent: "الجدران الجافة",
        subtitle: "خطط بذكاء قبل بدء مشروعك.",
        calculateArea: "احسب المساحة",
        heightPlaceholder: "الارتفاع (م)",
        widthPlaceholder: "العرض (م)",
        frameSingle: "إطار مفرد",
        frameDouble: "إطار مزدوج",
        boardOne: "لوح واحد لكل جانب",
        boardTwo: "لوحان لكل جانب",
        calculate: "احسب",
        note:
          "يرجى الملاحظة: النتائج المقدمة في هذا التقدير تقريبية وقد تختلف بنسبة ±10% حسب ظروف الموقع وممارسات التركيب.",
        callbackPrefix: "ما زلت غير متأكد من طريقة الحساب؟",
        callbackLink: "اطلب اتصالاً راجعاً",
        description: "الوصف",
        amount: "الكمية",
        totalArea: "الإجمالي {{unit}}",
        board: "لوح جبس 1,200×2400 مم (1.2×2.4 م)",
        trackUd: "بروفيل معدني مسار (UD)",
        studCw: "بروفيل معدني قائم (CW)",
        jointTape: "شريط الفواصل",
        jointCompound: "معجون الفواصل",
        screws25: "براغي دريوال (M3.5×25 مم)",
        screws35: "براغي دريوال (M3.5×35 مم)",
        waferHead: "برغي رأس عريض",
        anchors: "مراسي",
        studSpacing: "تباعد القوائم",
        studSpacingValue: "600 مم",
        waste: "الهدر",
        wasteValue: "5-10%",
        resultHint: "املأ الحقول واضغط احسب لمعاينة النتائج.",
        unitPcs: "قطعة",
        unitM: "م",
        unitKg: "كغ",
        downloadPdf: "تحميل PDF",
        pdfTitle: "تقرير مقدّر الجدران الجافة",
        pdfInput:
          "المدخلات: الارتفاع {{height}}م × العرض {{width}}م | {{frame}} | {{boardSides}}",
        pdfDateGenerated: "تاريخ الإنشاء: {{date}}",
        pdfNoteLabel: "ملاحظة:",
        pdfNoteText: "الهدر: 5-10% | الحساب يعتمد على تباعد قوائم 600 مم.",
      },
    },
    blog: {
      heroTitle: "مدونتنا",
      tag: "مقالات المدونة",
      listTitle: "آخر الأخبار والمقالات",
      readArticle: "اقرأ المقال",
      loadMore: "تحميل المزيد",
    },
    terms: {
      heroTitle: "الشروط والأحكام",
      heroDesc:
        "يرجى قراءة هذه الشروط بعناية قبل استخدام موقع IRQGYP أو التعامل مع منتجاتنا وخدماتنا. بدخولك إلى هذا الموقع، فإنك توافق على الالتزام بالشروط الموضحة أدناه.",
      lastUpdated: "آخر تحديث: أبريل 2026",
    },
    allSolutions: {
      constNeed: {
        tag: "حلولنا",
        titleLine1: "أنظمة متكاملة",
        titleLine2: "لكل",
        titleAccent: "احتياج بناء",
        intro: "تقدم IRQGYP حلولاً متكاملة في كل مراحل البناء، من الأساسات إلى التشطيبات النهائية.",
        moreDetails: "مزيد من التفاصيل",
      },
      products: {
        tag: "منتجاتنا",
        titleLine1: "استكشف فئات المنتجات",
        titleLine2: "ضمن حلولنا",
      },
      downloads: {
        tag: "التحميلات",
        title: "التحميلات المتاحة",
        descWithItems: "ملفات PDF تقنية من حلولنا — افتح أو حمّل من القائمة أدناه.",
        descEmpty: "لا تتوفر ملفات PDF للحلول حالياً. تحقق لاحقاً.",
      },
      requestProject: {
        tag: "اتصل بنا",
        title: "تبدأ",
        titleAccent: "مشروعاً جديداً؟",
        text: "IRQGYP شركة عراقية رائدة متخصصة في منتجات الجبس وحلول البناء الحديثة — مقرها بغداد.",
        getQuote: "احصل على عرض سعر",
        requestCallback: "طلب اتصال",
        imageAlt: "عامل يحمل لوح جبس",
      },
    },
    academy: {
      whyUs: {
        tag: "لماذا IRQGYP",
        title: "احصل على",
        titleAccent: "شهادة معترف بها في العراق",
        text: "مهاراتك تستحق الاعتراف. شهادة IRQGYP هي دليلك على الخبرة في أنظمة الجدران الجافة والبناء الحديث.",
        cta: "اكتشف الدورات",
        features: {
          f1: "معتمد من IRQGYP",
          f2: "معترف به في العراق والمنطقة",
          f3: "نتائج احترافية",
          f4: "ضمان التوظيف",
        },
      },
      courses: {
        tag: "الدورات",
        title: "الدورات",
        titleAccent: "المتاحة",
        text: "IRQGYP شركة عراقية رائدة متخصصة في منتجات الجبس وحلول البناء الحديثة — مقرها بغداد.",
      },
      getInTouch: {
        tag: "لنبقَ على تواصل",
        title: "هل لديك",
        titleAccent: "المزيد من الأسئلة؟",
        text: "سواء كنت تحتاج مزيداً من المعلومات عن منتجاتنا أو خدماتنا أو دعم المشروع، فريقنا هنا لمساعدتك.",
        formTitle: "املأ النموذج",
      },
      questions: {
        tag: "الأسئلة",
        title: "هل لديك",
        titleAccent: "المزيد من الأسئلة؟",
        text: "سواء كنت تحتاج مزيداً من المعلومات عن منتجاتنا أو خدماتنا أو دعم المشروع، فريقنا هنا لمساعدتك.",
        formTitle: "اطرح سؤالاً",
      },
    },
    careers: {
      openRoles: "الوظائف المتاحة",
      roleLabel: "الدور",
      noJobs: "لا توجد وظائف شاغرة حالياً.",
      followSubtitle: "تابعنا للاطلاع على الفرص الجديدة أو اشترك ليصلك إشعار.",
      emailPlaceholder: "أدخل بريدك الإلكتروني ليصلك إشعار بالوظائف الجديدة",
      subscribe: "اشترك",
      followSocial: "تابعنا على وسائل التواصل الاجتماعي",
      hero: {
        tag: "الوظائف",
        title: "انضم إلى فريقنا",
        description:
          "انضم إلى IRQGYP وابنِ مسيرتك المهنية ضمن فريق ديناميكي يقدّر الجودة والابتكار والتعاون، حيث تُقدَّر مهاراتك ويُبنى مستقبلك بهدفٍ وتأثير.",
        ctaText: "عرض الوظائف المتاحة",
      },
    },
    products: {
      boards: {
        tag: "الفئات",
        title: "الألواح",
        desc: "توفر ألواحنا أداءً عالياً ومتانة للاستخدام الداخلي والخارجي، مع قاعدة مستقرة للجدران والأسقف.",
        exploreAll: "استكشف كل المنتجات",
      },
      drywallFrame: "إطار معدني للجدران الجافة",
      ceilingFrame: "إطار معدني للأسقف",
      categoryHero: {
        tag: "الفئات",
        exploreAll: "استكشف كل المنتجات",
        accessories: {
          title: "الملحقات",
          desc: "صُممت ملحقاتنا لإكمال أنظمة الجدران الجافة والأسقف بدقة وموثوقية، مما يعزز كفاءة التركيب والأداء العام. وهي متوافقة بالكامل مع ألواحنا وأنظمة الإطارات المعدنية لضمان تشطيب آمن.",
        },
        drywall: {
          title: "إطار معدني للجدران الجافة",
          desc: "توفر أنظمة الإطارات المعدنية للجدران الجافة لدينا القوة والدقة والمتانة، لإنشاء هيكل موثوق للجدران والأسقف والفواصل. سهلة التركيب ومتوافقة بالكامل مع النظام لضمان الاستقرار والدقة والأداء طويل الأمد.",
        },
        ceiling: {
          title: "إطار معدني للأسقف",
          desc: "توفر أنظمة الإطارات المعدنية للأسقف لدينا القوة والاستقرار والدقة لتطبيقات الأسقف المعلقة، لإنشاء هيكل موثوق للأسقف المستوية والديكورية.",
        },
      },
      continueExploring: {
        titleLine1: "تابع الاستكشاف",
        titleLine2: "لفئات أخرى",
      },
      continueProducts: {
        tag: "المنتجات",
        titleLine1: "تابع الاستكشاف",
        titleLine2: "لمنتجات أخرى",
        desc: "نقدم مجموعة كاملة من مواد البناء عالية الجودة، بما في ذلك ألواح الجبس وبروفيلات الجدران والأسقف والملحقات.",
      },
      boardTabs: {
        keyFeatures: "الميزات الرئيسية",
        description: "الوصف",
        specifications: "المواصفات",
        applications: "التطبيقات",
        installationRecommendations: "توصيات التركيب",
        sustainability: "الاستدامة",
        storageTitleStrong: "التخزين والمناولة",
        storageTitleSoft: "والحماية في الموقع",
        disclaimer: "إخلاء المسؤولية",
        disclaimerBody:
          "تستند هذه الورقة إلى المعرفة التصنيعية الحالية والاختبارات المعملية. القيم المعلنة اسمية وقد تختلف ضمن حدود الإنتاج الطبيعية.",
      },
      detailTabs: {
        features: "الميزات",
        recommendations: "التوصيات",
        sustainability: "الاستدامة",
        standards: "المعايير",
        specifications: "المواصفات",
        dimensions: "الأبعاد",
        downloads: "التحميلات",
      },
    },
    projects: {
      exploreTitle: "استكشف كل المشاريع",
      sectorsFilter: "القطاعات:",
    },
    sectors: {
      tag: "القطاعات",
      title: "استكشف قطاعاتنا",
      aboutThisSector: "عن هذا القطاع",
      benefitsTitle: "فوائد حلول",
      benefitsTitleAccent: "IRQGYP",
      interiorWalls: "الجدران الداخلية",
      ceilingSystems: "أنظمة الأسقف",
      exteriorCladding: "الكسوة الخارجية",
    },
    solutions: {
      systemDescription: "وصف النظام",
      downloads: {
        tag: "التحميلات",
        title: "التحميلات المتاحة",
        description: "ملفات PDF التقنية والمستندات الخاصة بهذا الحل.",
        downloadAll: "تحميل كل الملفات",
        empty: "لا توجد تحميلات.",
      },
    },
    home: {
      blogPosts: {
        tag: "مقالات المدونة",
        title: "آخر الأخبار والمقالات",
        readArticle: "اقرأ المقال",
      },
    },
  },
  ku: {
    estimator: {
      hero: {
        badge: "خەمڵاندنی تێچوو",
        title: "خەمڵێنەری",
        titleLine2: "IRQGYP",
        desc1:
          "خەمڵێنەری IRQGYP یارمەتیت دەدات بڕیارێکی خێرا و ورد و ئاگادارانە بۆ پڕۆژەکەت بگریت پێش دەستپێکردنی بیناسازی.",
        desc2:
          "لەلایەن تیمە تەکنیکی و دیجیتاڵەکانمانەوە پەرەپێدراوە؛ ئەم ئامرازە ئۆنلاینە ڕێگە دەدات ئەندازیار، بەڵێندەر و بەڕێوەبەری پڕۆژە بڕی ماددەکان و داپۆشینی سیستەم و خەمڵاندنی تێچوو بۆ بەکارهێنانی گێپسوم حساب بکەن.",
        cta: "ئێستا خەمڵێنە",
        imageAlt: "خەمڵێنەر",
      },
      how: {
        tag: "چۆن کاردەکات",
        title: "بزانە",
        titleAccent: "خەمڵاندن چۆن کاردەکات",
        steps: {
          s1Title: "ڕووبەرەکەت بنووسە",
          s1Text: "کۆی ڕووبەری دەستنیشانکراو بنووسە و جۆری پێوانەکەت هەڵبژێرە.",
          s2Title: "جۆری دیوار و پڕۆفایل هەڵبژێرە",
          s2Text: "جۆری دیوار و پڕۆفایلی ئاسنەی گونجاو بۆ پڕۆژەکەت هەڵبژێرە.",
          s3Title: "لیستی ماددەکان وەربگرە",
          s3Text: "خەمڵێنەرەکە دەستبەجێ بڕی تەختەی گێپسوم، قوفڵ، پڕۆفایل و پڕکەر و لنگەرەکان دەردەکات.",
          s4Title: "خەمڵاندنەکەت دابگرە",
          s4Text: "ئەنجامەکان وەک PDF پاشەکەوت بکە پێش کڕینی ماددەکان یان دەستپێکردنی کار.",
        },
      },
      benefits: {
        title: "خەمڵێنەرەکەمان",
        titleAccent: "چۆن یارمەتیت دەدات",
        subtitle: "پێش دەستپێکردنی بیناسازی بڕی وردی ماددەکان دەداتێ",
        points: {
          p1: "کات لە پلاندانانی پڕۆژە دەپارێزێت",
          p2: "بەفیڕۆچوون و داواکاری زیادە کەم دەکاتەوە",
          p3: "بڕەکان لەگەڵ سیستەمە پشتڕاستکراوەکانی IRQGYP دەگونجێنێت",
          p4: "ڕاپۆرتی PDF دەستبەجێ بۆ پێشکەشکردن دروست دەکات",
          p5: "وردی لە زانین دەست پێدەکات.",
        },
        cta: "ئێستا خەمڵێنە",
        imageAlt: "کارمەندی خەمڵاندن",
      },
      calculator: {
        badge: "خەمڵێنەر",
        title: "خەمڵێنەری",
        titleAccent: "دیواری وشک",
        subtitle: "پێش دەستپێکردنی پڕۆژەکەت بە زیرەکی پلان دابنێ.",
        calculateArea: "ڕووبەر حساب بکە",
        heightPlaceholder: "بەرزی (م)",
        widthPlaceholder: "پانی (م)",
        frameSingle: "چوارچێوەی تاک",
        frameDouble: "چوارچێوەی دووانە",
        boardOne: "یەک تەختە بۆ هەر لایەک",
        boardTwo: "دوو تەختە بۆ هەر لایەک",
        calculate: "حساب بکە",
        note:
          "تکایە ئاگادار بە: ئەنجامەکانی ئەم خەمڵاندنە نزیکەنین و ڕەنگە بە ±10% جیاوازیان هەبێت بەپێی بارودۆخی شوێن و شێوازی دانان.",
        callbackPrefix: "هێشتا دڵنیایت نییە حسابکردن چۆن کاردەکات؟",
        callbackLink: "داوای پەیوەندی گەڕاوە بکە",
        description: "وەسف",
        amount: "بڕ",
        totalArea: "کۆی {{unit}}",
        board: "تەختەی گێپسوم 1,200×2400 مم (1.2×2.4 م)",
        trackUd: "پڕۆفایلی ئاسنەی ڕێڕەو (UD)",
        studCw: "پڕۆفایلی ئاسنەی ستاند (CW)",
        jointTape: "نووری پەیوەندی",
        jointCompound: "ماددەی پڕکەرەوەی پەیوەندی",
        screws25: "قوفڵی دیوار وشک (M3.5×25 مم)",
        screws35: "قوفڵی دیوار وشک (M3.5×35 مم)",
        waferHead: "قوفڵی سەری پان",
        anchors: "لنگەرەکان",
        studSpacing: "دووری ستاندەکان",
        studSpacingValue: "600 مم",
        waste: "بەفیڕۆچوون",
        wasteValue: "5-10%",
        resultHint: "خانەکان پڕ بکە و کلیک لە حساب بکە بکە بۆ پێشبینی ئەنجامەکان.",
        unitPcs: "دانە",
        unitM: "م",
        unitKg: "کگم",
        downloadPdf: "داگرتن بە PDF",
        pdfTitle: "ڕاپۆرتی خەمڵێنەری دیواری وشک",
        pdfInput:
          "تێخستن: بەرزی {{height}}م × پانی {{width}}م | {{frame}} | {{boardSides}}",
        pdfDateGenerated: "بەرواری دروستکردن: {{date}}",
        pdfNoteLabel: "تێبینی:",
        pdfNoteText: "بەفیڕۆچوون: 5-10% | حسابکردن بەپێی دووری ستاند 600 مم.",
      },
    },
    blog: {
      heroTitle: "بلۆگەکەمان",
      tag: "بابەتەکانی بلۆگ",
      listTitle: "دوایین هەواڵ و وتارەکان",
      readArticle: "وتارەکە بخوێنەوە",
      loadMore: "زیاتر بار بکە",
    },
    terms: {
      heroTitle: "مەرج و ڕێساکان",
      heroDesc:
        "تکایە ئەم مەرجانە بە وردی بخوێنەرەوە پێش بەکارهێنانی ماڵپەڕی IRQGYP یان کارکردن لەگەڵ بەرهەم و خزمەتگوزارییەکانمان.",
      lastUpdated: "دوایین نوێکردنەوە: نیسانی 2026",
    },
    allSolutions: {
      constNeed: {
        tag: "چارەسەرەکانمان",
        titleLine1: "سیستەمە یەکگرتووەکان",
        titleLine2: "بۆ هەموو",
        titleAccent: "پێداویستی بیناسازی",
        intro: "IRQGYP چارەسەری یەکگرتوو لە هەموو قۆناغەکانی بیناسازی پێشکەش دەکات، لە بناغە تا تەواوکاری.",
        moreDetails: "وردەکاری زیاتر",
      },
      products: {
        tag: "بەرهەمەکانمان",
        titleLine1: "پۆلەکانی بەرهەم بگەڕێ",
        titleLine2: "لە ناو چارەسەرەکانماندا",
      },
      downloads: {
        tag: "داگرتنەکان",
        title: "داگرتنە بەردەستەکان",
        descWithItems: "PDF ـی تەکنیکی لە چارەسەرەکانمان — لە لیستەکە بکەرەوە یان دایبگرە.",
        descEmpty: "ئێستا PDF ـی چارەسەر بەردەست نییە. دواتر سەردان بکەرەوە.",
      },
      requestProject: {
        tag: "پەیوەندیمان پێوە بکە",
        title: "پڕۆژەیەکی",
        titleAccent: "نوێ دەست پێدەکەیت؟",
        text: "IRQGYP کۆمپانیایەکی پێشەنگی عێراقی تایبەت بە بەرهەمەکانی گێپسوم و چارەسەری بیناسازی مۆدێرنە — ناوەندی لە بەغدا.",
        getQuote: "نرخ وەربگرە",
        requestCallback: "داوای پەیوەندی بکە",
        imageAlt: "کارمەندێک تەختەی گێپسوم هەڵدەگرێت",
      },
    },
    academy: {
      whyUs: {
        tag: "بۆچی IRQGYP",
        title: "بڕوانامەیەکی",
        titleAccent: "ناسراو لە عێراق وەربگرە",
        text: "شارەزاییەکەت شایەنی ناساندنە. بڕوانامەی IRQGYP بەڵگەی شارەزاییەکەتە لە سیستەمی دیواری وشک و بیناسازی مۆدێرن.",
        cta: "کۆرسەکان ببینە",
        features: {
          f1: "بڕوانامەی IRQGYP",
          f2: "ناسراو لە عێراق و هەرێم",
          f3: "ئەنجامی پیشەیی",
          f4: "دڵنیایی کار",
        },
      },
      courses: {
        tag: "کۆرسەکان",
        title: "کۆرسە",
        titleAccent: "بەردەستەکان",
        text: "IRQGYP کۆمپانیایەکی پێشەنگی عێراقی تایبەت بە بەرهەمەکانی گێپسوم و چارەسەری بیناسازی مۆدێرنە — ناوەندی لە بەغدا.",
      },
      getInTouch: {
        tag: "پەیوەندیمان پێوە بکە",
        title: "پرسیارت",
        titleAccent: "زیاتر هەیە؟",
        text: "ئەگەر زانیاری زیاتر دەربارەی بەرهەم، خزمەتگوزاری یان پشتگیری پڕۆژە پێویستت بێت، تیمەکەمان لێرەیە.",
        formTitle: "فۆرمەکە پڕ بکەرەوە",
      },
      questions: {
        tag: "پرسیارەکان",
        title: "پرسیارت",
        titleAccent: "زیاتر هەیە؟",
        text: "ئەگەر زانیاری زیاتر دەربارەی بەرهەم، خزمەتگوزاری یان پشتگیری پڕۆژە پێویستت بێت، تیمەکەمان لێرەیە.",
        formTitle: "پرسیارێک بکە",
      },
    },
    careers: {
      openRoles: "پۆستە کراوەکان",
      roleLabel: "پۆست",
      noJobs: "ئێستا هیچ پۆستێکی کراوە نییە.",
      followSubtitle: "بۆ دەرفەتی نوێ شوێنمان بکەوە یان بەشداری بکە بۆ ئاگاداربوونەوە.",
      emailPlaceholder: "ئیمەیڵەکەت بنووسە و بۆ پۆستی نوێ ئاگادار دەکرێیتەوە",
      subscribe: "بەشداری بکە",
      followSocial: "لە تۆڕە کۆمەڵایەتییەکان شوێنمان بکەوە",
      hero: {
        tag: "کار",
        title: "بەشداری تیمەکەمان بکە",
        description:
          "بەشداری IRQGYP بکە و پیشەکەت لە تیمێکی دینامیکیدا گەشە پێ بدە کە بایەخ بە کوالیتی و داهێنان و هاوکاری دەدات، لەوێ شارەزاییەکانت دەنرخێنرێن و داهاتووت بە مەبەست و کاریگەری دروست دەبێت.",
        ctaText: "پۆستە کراوەکان ببینە",
      },
    },
    products: {
      boards: {
        tag: "پۆلەکان",
        title: "تەختەکان",
        desc: "تەختەکانمان کارایی بەرز و بەردەوامی بۆ ناوەوە و دەرەوە دابین دەکەن، بنەمایەکی جێگیر بۆ دیوار و سەقف.",
        exploreAll: "هەموو بەرهەمەکان ببینە",
      },
      drywallFrame: "چوارچێوەی ئاسنی دیواری وشک",
      ceilingFrame: "چوارچێوەی ئاسنی سەقف",
      categoryHero: {
        tag: "پۆلەکان",
        exploreAll: "هەموو بەرهەمەکان ببینە",
        accessories: {
          title: "کەلوپەلەکان",
          desc: "کەلوپەلەکانمان بۆ تەواوکودنی سیستەمی دیواری وشک و سەقف بە وردی و متمانەپێکراوی دیزاین کراون، کارایی دامەزراندن و کارایی گشتی باشتر دەکەن. تەواو گونجاون لەگەڵ تەختە و سیستەمی چوارچێوەی ئاسنییەکانمان بۆ تەواوکاری پارێزراو.",
        },
        drywall: {
          title: "چوارچێوەی ئاسنی دیواری وشک",
          desc: "سیستەمی چوارچێوەی ئاسنی دیواری وشکمان هێز و وردی و بەردەوامی دابین دەکات، پێکهاتەیەکی متمانەپێکراو بۆ دیوار و سەقف و پارتیشن دروست دەکات. ئاسان بۆ دامەزراندن و گونجاو لەگەڵ سیستەمەکە بۆ جێگیری و وردی و کارایی درێژخایەن.",
        },
        ceiling: {
          title: "چوارچێوەی ئاسنی سەقف",
          desc: "سیستەمی چوارچێوەی ئاسنی سەقفمان هێز و جێگیری و وردی بۆ بەکارهێنانی سەقفی هەڵواسراو دابین دەکات، پێکهاتەیەکی متمانەپێکراو بۆ سەقفی تەخت و ڕازاندنەوە دروست دەکات.",
        },
      },
      continueExploring: {
        titleLine1: "بەدواداچوون بۆ",
        titleLine2: "پۆلەکانی تر",
      },
      continueProducts: {
        tag: "بەرهەمەکان",
        titleLine1: "بەدواداچوون بۆ",
        titleLine2: "بەرهەمەکانی تر",
        desc: "کۆمەڵەیەکی تەواوی ماددەی بیناسازی بە کوالیتی بەرز پێشکەش دەکەین، لەوانە تەختەی گێپسوم و پڕۆفایلی دیوار و سەقف.",
      },
      boardTabs: {
        keyFeatures: "تایبەتمەندییە سەرەکییەکان",
        description: "وەسف",
        specifications: "تایبەتمەندییەکان",
        applications: "بەکارهێنانەکان",
        installationRecommendations: "ڕاسپاردەکانی دامەزراندن",
        sustainability: "بەردەوامی",
        storageTitleStrong: "کۆگاکردن و مامەڵەکردن",
        storageTitleSoft: "و پاراستن لە شوێنی کار",
        disclaimer: "ڕاگەیاندن",
        disclaimerBody:
          "ئەم پەڕگەی زانیارییە لەسەر زانینی ئێستایی بەرهەمهێنان و تاقیکردنەوەی تاقیگەیی دامەزراوە.",
      },
      detailTabs: {
        features: "مەزییەکان",
        recommendations: "ڕاسپاردەکان",
        sustainability: "بەردەوامی",
        standards: "ستانداردەکان",
        specifications: "تایبەتمەندییەکان",
        dimensions: "ڕەهەندەکان",
        downloads: "داگرتنەکان",
      },
    },
    projects: {
      exploreTitle: "هەموو پڕۆژەکان بگەڕێ",
      sectorsFilter: "کەرتەکان:",
    },
    sectors: {
      tag: "کەرتەکان",
      title: "کەرتەکانمان بگەڕێ",
      aboutThisSector: "دەربارەی ئەم کەرتە",
      benefitsTitle: "سوودەکانی چارەسەرەکانی",
      benefitsTitleAccent: "IRQGYP",
      interiorWalls: "دیوارەکانی ناوەوە",
      ceilingSystems: "سیستەمی سەقف",
      exteriorCladding: "ڕووپۆشی دەرەوە",
    },
    solutions: {
      systemDescription: "وەسفی سیستەم",
      downloads: {
        tag: "داگرتنەکان",
        title: "داگرتنە بەردەستەکان",
        description: "پەڕگەکانی PDFی تەکنیکی و بەڵگەنامەکان بۆ ئەم چارەسەرە.",
        downloadAll: "هەموو پەڕگەکان داگرە",
        empty: "هیچ داگرتنێک نەدۆزرایەوە.",
      },
    },
    home: {
      blogPosts: {
        tag: "بابەتەکانی بلۆگ",
        title: "دوایین هەواڵ و وتارەکان",
        readArticle: "وتارەکە بخوێنەوە",
      },
    },
  },
};
